package com.fireavert.react.shared.components.custom_icons

import emotion.react.css
import mui.material.Tooltip
import mui.material.TooltipPlacement
import react.FC
import react.Props
import react.ReactNode
import react.dom.html.ReactHTML.div
import web.cssom.*

external interface V5FirmwareBadgeProps : Props {
    var className: ClassName?
}

val V5FirmwareBadge = FC<V5FirmwareBadgeProps> { props ->
    Tooltip {
        title = ReactNode("FireAvert version is 5.0 or higher")
        placement = TooltipPlacement.top

        div {
            className = props.className
            css {
                display = Display.inlineBlock
                backgroundColor = Color("#4CAF50") // Green color
                color = NamedColor.white
                padding = Padding(2.px, 6.px)
                borderRadius = 4.px
                fontSize = 11.px
                fontWeight = integer(600)
                marginLeft = 8.px
                cursor = Cursor.help
                lineHeight = number(1.2)
                verticalAlign = VerticalAlign.middle
            }
            +"V5"
        }
    }
}